<template>
  <layout-main-inner
    showBack
    :title="$route.meta.name+ `(${config.vendorName})`">
    <div
      v-if="permission.LVL2"
      slot="action">
      <el-button
        type="primary"
        @click="additem">新增证书</el-button>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.certName"
          clearable
          placeholder="请输入证书名称"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="证书名称"
          min-width="180"
          prop="certName"> </el-table-column>
        <el-table-column
          label="证书图片"
          min-width="360px">
          <template slot-scope="{row}">
            <image-list :list="row.certFile" />
          </template>
        </el-table-column>
        <el-table-column
          label="有效期"
          min-width="180">
          <template slot-scope="{row}">
            {{ row.certBeginTime | dateformat('YYYY-MM-DD') }} ~ {{ row.certEndTime | dateformat('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="135">
          <template slot-scope="{ row }">
            <template v-if="permission.LVL2">
              <el-button
                type="text"
                @click="updateitem(row)"> 管理证书文件 </el-button>
              <el-button
                type="text"
                @click="deleteitem(row)"> 删除 </el-button>
            </template>
            <el-button
              v-else
              type="text"
              @click="updateitem(row)"> 查看证书文件 </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="totalNum"
        @current-change="handleCurrentChange">  </el-pagination>
    </layout-card-wrap>

    <certificate-modal
      ref="modal"
      @fetch="getlist" />
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import ImageList from '../../../components/image-list.vue'
import CertificateModal from './certificate-modal.vue'
export default {
  name: 'VendorCertificateList',
  components: { CertificateModal, ImageList },
  data() {
    return {
      loading: true,
      list: [],
      totalNum: 0,
      config: { certName: '', vendorName: '', vendorId: null }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo,
      permission: (state) => state.account.permission
    })
  },
  mounted() {
    this.config = { ...this.config, ...this.$route.query }
    this.getlist()
  },
  methods: {
    additem() {
      this.$refs.modal.init({ vendorId: this.config.vendorId })
    },
    updateitem(row) {
      const { vendorName, vendorId, certName, certId } = row
      this.$router.push({ path: '/certificate-file', query: { vendorName, vendorId, certName, certId }})
    },
    deleteitem(row) {
      this.$confirm('您确定删除该证书?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$examApi.deletecertificate({ vendorId: row.vendorId, certId: row.certId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.$message.success('删除成功')
                this.getlist()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$$examApi.getcertificates(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(i => ({ ...i, certFile: this.$splitImage(i.certFile) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
